module.exports = __webpack_public_path__ + "img/stock7.acefe822.png";